import { z } from "zod";

export const handleMarketingEmailUnsubscribeSchema = {
  input: z.object({}),
  output: z.object({}),
};
